// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sendMsg[data-v-d1cb50c2]{padding:8px 10px;display:flex;flex-direction:column}.sendMsg span[data-v-d1cb50c2]{color:#303133;cursor:pointer;font-size:14px;border-bottom:1px solid #e4e7ed;margin:2px 0;padding-bottom:2px;padding-left:8px;padding-right:8px}.sendMsg span[data-v-d1cb50c2]:hover{color:#1da373}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
